<template>
    <ion-content>

        <ion-loading v-if="showLoading" cssClass=""
            :message="addressType == 'billing' ? 'Loading Billing Addresses' : 'Loading Shipping Addresses'"></ion-loading>

        <ion-header>
            <ion-toolbar>

                <ion-buttons slot="end" v-if="isModal">
                    <ion-button @click="$modal.hide('list-address')">❌</ion-button>
                </ion-buttons>
                <ion-label style="padding: 20px 100px;">
                    <h1>{{ addressType == 'billing' ? 'Billing Addresses' : 'Shipping Addresses' }}</h1>
                </ion-label>
            </ion-toolbar>
        </ion-header>


        <div v-if="!showLoading && addresses.count == 0">No addresses yet. Create one?</div>
        <ion-grid>
            <ion-row>
                <ion-col size="12" size-md="3" v-for="address in addresses" :key="address._id">
                    <ion-card class="min-height">
                        <ion-card-header>
                            <ion-card-title>{{ addressType == 'billing' ? 'Billing Address' : 'Shipping Address'
                            }}</ion-card-title>
                            <ion-card-subtitle>Street 1: <span>{{ address.street1 }}</span></ion-card-subtitle>
                            <ion-card-subtitle>City: <span>{{ address.city }}</span></ion-card-subtitle>
                        </ion-card-header>
                        <ion-card-content>
                            <ion-label>First Name:<span>{{ address.firstName }}</span></ion-label>
                            <br>
                            <ion-label>Phone: <span>{{ address.phone }}</span></ion-label>
                        </ion-card-content>
                        <ion-footer>
                            <ion-chip v-if="!isShow" @click="addressSelected(address)">Select</ion-chip>
                            <ion-chip v-if="!isShow" @click="editAddress(address._id)">Edit</ion-chip>
                            <template v-if="addressType == 'billing'">
                                <ion-chip v-if="!address.isDefault" @click="setAsDefaultBilling(address._id)">Set as
                                    default</ion-chip>
                                <ion-chip color="primary" v-if="address.isDefault">Default</ion-chip>
                            </template>
                            <template v-if="addressType == 'shipping'">
                                <ion-chip v-if="!address.isDefault" @click="setAsDefaultShipping(address._id)">Set as
                                    default</ion-chip>
                                <ion-chip color="primary" v-if="address.isDefault">Default</ion-chip>
                            </template>
                        </ion-footer>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>

        <ion-button @click="createNewAddress">Create a new Address</ion-button>
    </ion-content>
</template>



<script>
import { Api } from '../../backoffice/api/api.js';
import Swal from 'sweetalert2';

export default {
    name: 'AddressList',
    props: {
        addressType: String,
        userId: String,
        isModal: {
            type: Boolean,
            default: true
        },
        isShow:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            addresses: [],
            showLoading: false,
            contentUpdate: Math.random(),
        }
    },
    methods: {
        addressSelected(address) {
            this.$emit('address-selected', address);
        },
        createNewAddress() {
            this.$emit('create-address', this.addressType);
        },
        editAddress(address) {
            console.log({address})
            this.$emit('edit-address', address);
        },
        /**
     * Set Address as default
     * @param {} addressId 
     */
        setAsDefaultShipping(addressId) {

            Api.setAddressAsDefault(addressId).then(response => {
                //console.log(response);
                if (response) {
                    //reload the data
                    this.loadAddresses();
                    let update = Math.random();
                    this.$emit('update-address', update++);
                    Swal.fire({
                        title: 'Updated default shipping address',
                        backdrop:false,
                    });
                } else {
                    Swal.fire({
                        title: 'Something went wrong',
                        backdrop:false,
                    });
                }

            });
        },

        setAsDefaultBilling(addressId) {

            Api.setAddressAsDefault(addressId).then(response => {
                //console.log(response);
                if (response) {
                    //reload the data
                    this.loadAddresses();
                    this.$emit('update-address', this.contentUpdate++);
                    Swal.fire({
                        title: 'Updated default shipping address',
                        backdrop:false,
                    });
                } else {
                    Swal.fire({
                        title: 'Something went wrong',
                        backdrop:false,
                    });
                }

            });
        },
        updateAddress(value) {
        this.contentUpdate++;
            // console.log("value",{value})
            this.$emit('update-address', this.contentUpdate);
        },
        loadAddresses() {

            this.showLoading = true;
            Api.getAddressByUser(this.userId, this.addressType).then(response => {

                if (response) {
                    this.addresses = response.data.data.filter(item => item.type == this.addressType);
                    console.log(this.addresses, this.userId, this.addressType)
                } else {
                    //do nothing
                }
                this.showLoading = false;
            });
        }
    },
    created() {
        //load all the addresses and filter
        this.loadAddresses();
    },

};
</script>

<style></style>